// extracted by mini-css-extract-plugin
export default {"container":"ProgressBar_container__gagAx","progress":"ProgressBar_progress__Ob5Q6"};